import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AiFillCopy } from 'react-icons/ai';
import Snackbar from '@material-ui/core/Snackbar';

import {
  CalcSolution,
  SolutionWrapper,
  Parag,
  CopyButton,
} from '../../styled/stylezz';

const SpanBold = styled.span`
  &&& {
    font-size: 1.2em;
    font-size: bold;
    padding: 15px;
  }
`;

const SolutionCalc = ({ inputX: X, inputY: Y }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [sol, setSol] = useState(0);

  useEffect(() => {
    const discount = (Y / 100) * X;
    setDiscount(discount);
    const sol = +X - discount;
    setSol(sol);
  }, [X, Y]);

  const handleCopy = () => {
    navigator.clipboard.writeText(sol);
    setOpenSnackBar(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };
  return (
    <SolutionWrapper>
      <>
        <Parag>Ответ:</Parag>
        <CalcSolution>
          <p>
            <SpanBold>Начальная цена: {X}</SpanBold>
          </p>
          <p>
            <SpanBold>Скидка в процентах: {Y}%</SpanBold>
          </p>
          <p>
            <SpanBold>Размер скидки: {discount}</SpanBold>
          </p>
          <p>
            <SpanBold>Цена со скидкой: {sol}</SpanBold>
          </p>
          <CopyButton onClick={handleCopy}>
            <AiFillCopy
              size={20}
              style={{ color: '#5095df', marginRight: '10px' }}
            />
            Копировать ответ
          </CopyButton>
          <Snackbar
            achororigin={{
              vertical: 'center',
              horizontal: 'center',
            }}
            open={openSnackBar}
            autoHideDuration={2000}
            message="Ответ скопирован"
            onClose={handleClose}
            ContentProps={{
              style: {
                background: '#5095df',
              },
            }}
          />
        </CalcSolution>
      </>
    </SolutionWrapper>
  );
};

export default SolutionCalc;
